export default [
  {
    title: 'Factories',
    icon: 'mdi-factory',
    to: 'FactoryManagement',
    keywords: ['โรงงาน', 'ผู้ผลิต', 'factory']
  },
  {
    title: 'Fabric Factories',
    icon: 'mdi-factory',
    to: 'FabricFactoryManagement',
    keywords: ['โรงงานผ้า', 'ผู้ผลิตผ้า', 'fabric', 'factory']
  },
  {
    title: 'Material Factories',
    icon: 'mdi-factory',
    to: 'MaterialFactoryManagement',
    keywords: ['โรงงานวัตถุดิบ', 'ผู้ผลิตวัสดุ', 'material', 'factory']
  },
  {
    title: 'Squad Members',
    icon: 'mdi-account-cog-outline',
    to: 'SquadMemberManagement',
    keywords: ['สมาชิกทีม', 'ทีมงาน', 'squad', 'member', 'team']
  },
  {
    title: 'Sub-categories',
    icon: 'mdi-shape-outline',
    to: 'SubCategoryManagement',
    keywords: ['หมวดหมู่ย่อย', 'ประเภทย่อย', 'sub', 'category']
  }
]
